import { memo } from 'react';

import { getScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import {
  ActionDuplicateButton,
  ActionRemoveButton,
  nodeToActionBasic,
} from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { ConvertButton } from './convert-button';

const ACTION_TYPE = ACTION_TYPES.placeholder;

export const getDescription = (action: JourneyAction<typeof ACTION_TYPE>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={getActionLabel(ACTION_TYPE)}>
        <ActionRemoveButton action={nodeToActionBasic(node)} size="md" />
        <ActionDuplicateButton journeyActionShortId={node.id} size="md" />
        <ConvertButton journeyActionShortId={node.id} size="md" />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    noDescription: 'No description',
  },
};
